module.exports = __webpack_public_path__ + "img/passport-wrong-unreadable.5d443ef8.png";